import {Rows} from "Components/Layout/Table";

const DealGroupTable: Rows = {
    id: {
        placeholders: [
            {
                element: 'p',
                size: 1
            }
        ]
    },
    name: {
        placeholders: [
            {
                element: 'p',
                size: [3, 1],
            }
        ]
    },
    actions: {
        className: 'actions',
        sortable: false,
        placeholders: [
            {
                element: 'a',
                size: 2,
            },
        ]
    },
};

export default DealGroupTable